/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Cancel from '../../assets/images/cancel.png';
import PaymentAction from '../../store/actions/PaymentAction';

function PaymentCancel() {
  const location = useLocation();
  const dispatch = useDispatch();
  const queryParams = queryString.parse(location.search);
  const { token } = queryParams; // Use object destructuring to extract token

  useEffect(() => {
    if (token !== undefined) {
      dispatch(PaymentAction.paypalCancel(token));
    }
  }, [dispatch, token]);

  return (
    <Box className="invoiceAppLoginWrap">
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={5} md={5}>
          <Box className="loginRightForm">
            <Box
              className="loginFormWrap"
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh'
              }}
            >
              <Box className="logninInner">
                <img alt="Payment Cancelled" src={Cancel} />
                <Typography variant="h3" gutterBottom component="" mb={2}>
                  Sorry, Payment Cancelled
                </Typography>
                <Typography
                  variant="body1"
                  align="center"
                  className="subtitle"
                  sx={{ fontSize: '16px !important' }}
                  component="p"
                  mb={2}
                >
                  Your payment has cancelled. Please review the payment details and try again.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default PaymentCancel;
